export default __webpack_public_path__ + "static/media/logoo.5e705927.png";